<label class="">
  <span>{{ description }}</span>
</label>
<div>
  <app-stars [value]="value" (selectedValue)="onRatingChange($event)">
  </app-stars>
</div>
